import { tranStr } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";
import { getDmsToken } from "../../active-directory/getDmsToken";
import { authHeader } from "../../_helpers/auth-header";
import { AutoCloseModal } from "../../components/modal/Modal";
import { pc2APIs } from "../api-endpoints/PostContract2.0Endpoints";

export async function deleteKeyDocument(documentId, projectId, postContractId) {
  // COST PLAN API
  const url =
    pc2APIs().delete_key_document +
    "?projectId=" +
    projectId +
    "&postContractId=" +
    postContractId +
    "&documentId=" +
    documentId;

  const dmsToken = await getDmsToken();
  let dmsBearer = "";
  if (!isEmpty(dmsToken)) {
    dmsBearer = dmsToken.accessToken;
  }

  const config = {
    method: "POST",
    headers: {
      ...authHeader({ authJson: true, authForm: false, guestJson: false }),
      dmsBearer: `Bearer ${dmsBearer}`,
    },
  };

  let response = await fetch(url, config);
  if (response.ok) {
    // Response OK
  } else {
    console.log("Delete Project Drawing Error");
  }
}

export async function uploadKeyDocument(data) {
  if (data.file.length < 1) {
    return data.setError({
      text: tranStr("Please attach file"),
      type: "feedback-error",
    });
  }

  data.setError({
    text: tranStr("Creating..."),
    type: "feedback-success",
  });

  const formData = new FormData();
  formData.append("file", data.file[0]);

  // COST PLAN API
  const url =
    pc2APIs().upload_key_document +
    "?projectId=" +
    data.projectId +
    "&postContractId=" +
    data.postContractId;

  const dmsToken = await getDmsToken();
  let dmsBearer = "";
  if (!isEmpty(dmsToken)) {
    dmsBearer = dmsToken.accessToken;
  }

  const config = {
    method: "POST",
    body: formData,
    headers: {
      ...authHeader({ authJson: false, authForm: true, guestJson: false }),
      dmsBearer: `Bearer ${dmsBearer}`,
    },
  };

  let response = await fetch(url, config);
  if (response.ok) {
    // Response OK
    data.postContract.set(
      await data.postContract.get(
        data.projectId,
        data.postContractId,
        "Key Documents"
      )
    );

    data.setError({
      text: tranStr("Created Successfully"),
      type: "feedback-success",
    });

    // close modal after timeout
    AutoCloseModal(data.setShow);
  } else {
    return data.setError({
      text: tranStr("Connection Error"),
      type: "feedback-error",
    });
  }
}
